<template>
  <v-form  ref="form mb-3">
    <v-card class="form-2fa" style="border-radius: 10px;">
      <div style="display:flex; justify-content: flex-end; padding: 10px;">
        <span @click="$emit('on-close')">
          <v-icon class="close-icon">close</v-icon>
        </span>
      </div>
      <v-container>
          <v-icon class="lock">lock</v-icon>
          <h1 class="auth-title">{{l('Google Autenticador')}}</h1>
          <p style="text-align: center;" class="description">{{l('Digite o código de 6 dígitos do seu aplicativo Google Authenticator')}}</p>
          <v-flex class="mt-4 mb-2 digits-container">
            <input
              ref="digitZero"
              v-model="digits[0]"
              @keypress="isNumber($event)"
              @keyup="nextInput($event, 0)"
              @keydown="onKeyDown($event, 0)"
              @focus="$event.target.select()"
              maxlength="1"
              class="single-digit-input"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <input
              ref="digitOne"
              v-model="digits[1]"
              @keypress="isNumber($event)"
              @keyup="nextInput($event, 1)"
              @keydown="onKeyDown($event, 1)"
              @focus="$event.target.select()"
              maxlength="1"
              class="single-digit-input"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <input
              ref="digitTwo"
              v-model="digits[2]"
              @keypress="isNumber($event)"
              @keyup="nextInput($event, 2)"
              @keydown="onKeyDown($event, 2)"
              @focus="$event.target.select()"
              maxlength="1"
              class="single-digit-input"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <input
              ref="digitThree"
              v-model="digits[3]"
              @keypress="isNumber($event)"
              @keyup="nextInput($event, 3)"
              @keydown="onKeyDown($event, 3)"
              @focus="$event.target.select()"
              maxlength="1"
              class="single-digit-input"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <input
              ref="digitFour"
              v-model="digits[4]"
              @keypress="isNumber($event)"
              @keyup="nextInput($event, 4)"
              @keydown="onKeyDown($event, 4)"
              @focus="$event.target.select()"
              maxlength="1"
              class="single-digit-input"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <input
              ref="digitFive"
              v-model="digits[5]"
              @keypress="isNumber($event)"
              @keyup="nextInput($event, 5)"
              @keydown="onKeyDown($event, 5)"
              @focus="$event.target.select()"
              maxlength="1"
              class="single-digit-input"
              inputmode="numeric"
              pattern="[0-9]*"
            />
          </v-flex>
          <p class="red--text raised-error" v-if="hasError">{{errorMsg}}</p>
      </v-container>

      <v-card-actions style="padding: 16px;">
        <v-btn class="btn-2fa btn-style--gray" block dark @click.stop.prevent="resetInputs(true)">{{l('RESETAR')}}</v-btn>
        <v-btn class="btn-2fa btn-style-green" block dark @click.stop.prevent="onSubmit()">{{l('Confirmar')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
export default {
  name: 'TwoFactorAuthenticationForm',
  data() {
    return {
      digits: [
        "", // digits[0]
        "", // digits[1]
        "", // digits[2]
        "", // digits[3]
        "", // digits[4]
        ""  // digits[5]
      ],
      hasError: false,
      errorMsg: '',
      inputHadContentBeforeBackspace: false,
    }
  },
  mounted() {
    // delay for animation end (on modal open)
    setTimeout(() => this.$refs.digitZero.focus(), 900);
  },
  methods: {
    l(str) {
      return this.$root.l(str)
    },
    onOpen() {
      // delay for animation end (on modal open)
      setTimeout(() => this.$refs.digitZero.focus(), 500);
    },
    onKeyDown(event, from) {
      if(event.key === 'Backspace' && this.digits[from] !== '') {
        this.inputHadContentBeforeBackspace = true
      }
      else {
        this.inputHadContentBeforeBackspace = false
      }
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    previousInput(from) {
      switch(from) {
        case 1:
          this.$refs.digitZero.focus();
          break;
        case 2:
          this.$refs.digitOne.focus();
          break;
        case 3:
          this.$refs.digitTwo.focus();
          break;
        case 4:
          this.$refs.digitThree.focus();
          break;
        case 5:
          this.$refs.digitFour.focus();
          break;
      }
    },
    nextInput(event, from) {
      if(event.key === 'Enter' && from === 5) {
        this.onSubmit();
        return
      }
      if(event.key === 'Backspace') {
        if(this.inputHadContentBeforeBackspace) {
          return;
        }
        else {
          this.previousInput(from)
          return;
        }
      }
      if(
        event.key === 'ArrowLeft'
      ) {
        this.previousInput(from)
        return;
      }
      // If any non-digit key is pressed, return
      let match = event.key.match(/[^0-9]/g)
      if(match !== null) {
        return;
      }
      switch(from) {
        case 0:
          this.$refs.digitOne.focus();
          break;
        case 1:
          this.$refs.digitTwo.focus();
          break;
        case 2:
          this.$refs.digitThree.focus();
          break;
        case 3:
          this.$refs.digitFour.focus();
          break;
        case 4:
          this.$refs.digitFive.focus();
          break;
      }
    },
    onSubmit() {
      const code = this.digits.join('')
      this.$emit('on-submit', code)
    },
    raiseError(msg) {
      this.errorMsg = msg
      this.hasError = true
      this.resetInputs()
    },
    resetInputs(clearErrors = false) {
      if(clearErrors) {
        this.hasError = false
      }
      this.inputHadContentBeforeBackspace = false
      this.digits = ["", "", "", "", "", ""]
      this.$refs.digitZero.focus()
    }
  },
}
</script>

<style>
.auth-title{
  letter-spacing: 0.03em;
  text-align: center;
  font-size: 30px;
  padding-top: 20px !important;
  padding-bottom: 5px;
}
.description{
  color: #BCC1D1 !important;
  font-weight: 300;
  padding: 7px 0;
  font-size: 17px;
}
.digits-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.single-digit-input:focus {
  outline-width: 0px;
  border: 2px var(--primary-light-font-color) solid;
}
.single-digit-input {
  color: var(--secondary-button-background-color);
  border: 2px var(--secondary-button-background-color) solid;
  border-radius: 5px;
  width: 30px;
  margin: 8px;
  padding: 10px;
  text-align: center;

  font-family: Paralucent;
  font-size: 24px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: 0.03em;
}
@media only screen and (min-width: 300px) {
  .single-digit-input {
  width: 43px;
  margin: 10px;
  padding: 10px;
  font-size: 24px;
}
}
.raised-error {
  margin: 10px 0;
  text-align: center;
}

.btn-2fa{
  background-color:var(--secondary-button-background-color) !important;
  color: var(--navigation-color) !important;
  border-radius: 5px;
  padding: 30px 0;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: 0.1em;
}

.form-2fa{
  height: 100%!important;
  background-color: var(--background-color) !important;

}
.form-2fa h1{
  color: white !important;
  padding-top: 10px;

}

.close-icon {
  background-color: var(--background-color);
  color: var(--primary-light-font-color) !important;
}
.close-icon:hover {
  color: var(--secondary-button-background-color) !important;
  cursor: pointer;
}
.lock{
  color:lightgray !important;
  background-color: gray;
  border: 1px  gray solid;
  border-radius: 100%;
  padding: 15px;
  font-size: 70px;
}
.btn-style--gray {
    background-color: var(--dark-blue)!important;
    color: var(--silver-color-font-color)!important;
  }
.btn-style-green {
  background-color: var(--secondary-button-background-color)!important;
  height: 56px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/TwoFactorAuthenticationForm.vue